(function($) {
    $(document).ready(function() {

        // if ( $('.hero-video').length > 0) {
        //         
        //     $('.hero-video').vide({
        //         mp4 : vimeoURL,
        //         poster: '' ,
        //     }, {
        //         volume: 0,
        //         playbackRate: 1,
        //         muted: true,
        //         loop: true,
        //         autoplay: true,
        //         position: '50% 50%',
        //         posterType: 'none', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
        //         resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
        //         // bgColor: '#ffb600', // Allow custom background-color for Vide div,
        //     });
        // }
        //
         $(".content").fitVids();

         $(".video").fitVids();

        $(window).load(function() {
            var $lazyVid = $('.lazy-video');
            var $src = $lazyVid.attr('data-src');
            $lazyVid.attr('src', $src).delay(100).fadeIn();
        });

    });
})(jQuery); 
